import { __assign, __makeTemplateObject } from "tslib";
import * as React from 'react';
import styled, { css } from 'styled-components';
import { style } from 'styled-system';
import asRendition from '../../asRendition';
import { monospace } from '../../utils';
export var whitespace = function (props) {
    return props.whitespace
        ? css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\t\t\t\twhite-space: ", ";\n\t\t  "], ["\n\t\t\t\twhite-space: ", ";\n\t\t  "])), props.whitespace) : null;
};
export var caps = function (props) {
    return props.caps
        ? css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\t\t\t\ttext-transform: uppercase;\n\t\t\t\tletter-spacing: 0.2em;\n\t\t  "], ["\n\t\t\t\ttext-transform: uppercase;\n\t\t\t\tletter-spacing: 0.2em;\n\t\t  "]))) : null;
};
export var italic = function (props) {
    return props.italic
        ? css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\t\t\t\tfont-style: italic;\n\t\t  "], ["\n\t\t\t\tfont-style: italic;\n\t\t  "]))) : null;
};
export var bold = function (props) {
    return props.bold
        ? css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\t\t\t\tfont-weight: ", ";\n\t\t  "], ["\n\t\t\t\tfont-weight: ", ";\n\t\t  "])), props.theme.weights[props.theme.weights.length - 1]) : null;
};
export var align = style({
    key: 'text-align',
    prop: 'align',
    cssProperty: 'text-align',
});
var BaseTxt = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n\t", "\n\t", "\n\t", "\n\n\t", "\n\t", "\n\t", "\n"], ["\n\t", "\n\t", "\n\t", "\n\n\t", "\n\t", "\n\t", "\n"])), align, monospace, whitespace, caps, bold, italic);
var Factory = function (tag) {
    return asRendition(function (props) {
        return React.createElement(BaseTxt, __assign({ as: tag }, props));
    });
};
var Base = Factory();
Base.displayName = 'Txt';
Base.span = Factory('span');
Base.p = Factory('p');
export var Txt = Base;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
